"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMomentObjInterval = exports.defaultISOInterval = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startDate = (0, _moment.default)().subtract(29, 'days').startOf('day');
var endDate = (0, _moment.default)().endOf('day');
var defaultISOInterval = {
  startDate: startDate.toISOString(),
  endDate: endDate.toISOString()
};
exports.defaultISOInterval = defaultISOInterval;
var defaultMomentObjInterval = {
  startDate: startDate,
  endDate: endDate
};
exports.defaultMomentObjInterval = defaultMomentObjInterval;